import React from 'react'
import '../assets/css/Home.css'
import Image from '../assets/images/index.svg'
import {useNavigate} from "react-router-dom";
function Home() {
    const navigate = useNavigate()
    return (
        <div className="d-flex flex-column h-100">
            <h1 className="pt-5 text-center">خوش آمدید!</h1>
                <div className="flex-fill d-flex flex-column justify-content-center">
                    <img src={Image} alt="" className="home-image d-block mt-0 mx-auto"/>
                </div>
                <div className="row justify-content-center">
                <div className="col-sm-3 button-container">
                        <button className="btn btn-filled" onClick={() => navigate('/login')}>ورود</button>
                    </div>
                    <div className="col-sm-3 button-container">
                        <button className="btn btn-filled" onClick={() => navigate('/register')}>ثبت نام</button>
                    </div>
                </div>
        </div>
    );
}

export default Home;
